import { useState } from "react";
import {
  PRESCRIPTION_CHOICE_LABEL,
  PUBLISH_TO_PATIENT_CTA,
} from "@care-by-ella/contracts";
import { WebdocControlStep } from "./WebdocControlStep";

// TES-1055 (Emelie, point H) — "Nytt recept är utfärdat i Webdoc" recorded
// later, on the live cycle. It replaces a `window.confirm`: recording it
// stamps prescribedAt and gives her the pickup task, so it goes through the
// same Webdoc step as every other publish of a prescription. The publish
// stays disabled until "Journalanteckningen är införd i Webdoc"
// is ticked, and the API refuses it without the tick.
export function IssuePrescriptionDialog({
  cycleNumber,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  cycleNumber: number;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const [journalDone, setJournalDone] = useState(false);
  return (
    <div className="fixed inset-0 z-50 flex items-stretch justify-center bg-black/30 sm:items-center sm:p-md">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="issue-prescription-title"
        className="flex h-full w-full flex-col gap-md overflow-y-auto bg-surface p-md sm:h-auto sm:max-h-[90vh] sm:max-w-md sm:rounded-md sm:p-lg"
      >
        <h3 id="issue-prescription-title" className="font-display text-xl">
          {PRESCRIPTION_CHOICE_LABEL.new_issued}
        </h3>
        <p className="text-sm text-textSecondary">
          Cykel {cycleNumber}. Receptet registreras som utfärdat av dig nu, och
          patienten får uppgiften att hämta ut läkemedlet.
        </p>
        <WebdocControlStep
          idPrefix="issue-prescription"
          journal={{ done: journalDone, onChange: setJournalDone }}
          labOrder={false}
          labOrderDone={false}
          onLabOrderDoneChange={() => undefined}
          disabled={busy}
        />
        {error ? (
          <p className="rounded-md border border-danger/30 bg-danger/10 p-sm text-sm text-danger">
            {error}
          </p>
        ) : null}
        <div className="flex justify-end gap-sm">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded-md px-md py-sm text-sm text-textSecondary hover:bg-surfaceMuted"
          >
            Avbryt
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy || !journalDone}
            className="rounded-md bg-brand px-md py-sm text-sm text-textOnBrand hover:opacity-90 disabled:opacity-60"
          >
            {busy ? "Publicerar…" : PUBLISH_TO_PATIENT_CTA}
          </button>
        </div>
      </div>
    </div>
  );
}
